/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Closing_Lede_1Inputs */

const en_home_closing_lede_1 = /** @type {(inputs: Home_Closing_Lede_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hours lost, leads missed, research nobody has time for.`)
};

const lv_home_closing_lede_1 = /** @type {(inputs: Home_Closing_Lede_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaudētas stundas, neapstrādāti klienti, izpēte, kurai nevienam nav laika.`)
};

/**
* | output |
* | --- |
* | "Hours lost, leads missed, research nobody has time for." |
*
* @param {Home_Closing_Lede_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_closing_lede_1 = /** @type {((inputs?: Home_Closing_Lede_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Closing_Lede_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_closing_lede_1(inputs)
	return en_home_closing_lede_1(inputs)
});